import DouglasURL, { ReactComponent as Douglas } from "./Douglas.svg"
import InStyleURL, { ReactComponent as InStyle } from "./InStyle.svg"
import WeltURL, { ReactComponent as Welt } from "./Welt.svg"
import GlamourURL, { ReactComponent as Glamour } from "./Glamour.svg"
import ARDURL, { ReactComponent as ARD } from "./ARD.svg"
import VISAURL, { ReactComponent as VISA } from "./VISA.svg"
import CosmopolitanURL, { ReactComponent as Cosmopolitan } from "./Cosmopolitan.svg"
import RTLURL, { ReactComponent as RTL } from "./RTL.svg"
import SZURL, { ReactComponent as SZ } from "./SZ.svg"
import DHLURL, { ReactComponent as DHL } from "./DHL.svg"
import ProSiebenURL, { ReactComponent as ProSieben } from "./pro7.svg"
import PayPalURL, { ReactComponent as PayPal } from "./paypal-logo.svg"
import SleepInkURL, { ReactComponent as SleepInk } from "./SleepInk.svg"

const componentMap = {
  Douglas,
  InStyle,
  Welt,
  Glamour,
  ARD,
  VISA,
  Cosmopolitan,
  RTL,
  ProSieben,
  SZ,
  DHL,
  PayPal,
  SleepInk,
}

const urlMap = {
  Douglas: DouglasURL,
  InStyle: InStyleURL,
  Welt: WeltURL,
  Glamour: GlamourURL,
  ARD: ARDURL,
  VISA: VISAURL,
  Cosmopolitan: CosmopolitanURL,
  RTL: RTLURL,
  ProSieben: ProSiebenURL,
  SZ: SZURL,
  DHL: DHLURL,
  PayPal: PayPalURL,
  SleepInk: SleepInkURL,
}

export { componentMap, urlMap }
